import findKey from 'lodash-es/findKey'

import { filterVisibleItems } from '../../../../../utils/common'

import {
  LISTING_PROFILE_HEADER_FOOTER_ACTION,
  LISTING_PROFILE_HEADER_FOOTER_ACTION_ITEMS,
  LISTING_PROFILE_HEADER_FOOTER_ACTION_PERMISSION_NAME,
  LISTING_PROFILE_HEADER_FOOTER_ACTION_QA_NAME,
  LISTING_PROFILE_HEADER_FOOTER_ACTION_TEXT_KEY,
  LISTING_PROFILE_HEADER_FOOTER_ACTION_UNAVAILABLE_TOOLTIP_KEY,
  LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_ICON,
  LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_PERMISSION_NAME,
  LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_QA_NAME,
  LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_TEXT_KEY,
} from './RentalPortalListingProfileHeaderFooter.constants'

function getActionDisabledTooltipKey({ action, applicantCount }) {
  return action === LISTING_PROFILE_HEADER_FOOTER_ACTION.emailApplicant &&
    applicantCount === 0
    ? 'RentalPortal.ListingProfileFooterEmailApplicantNoneTooltipKey'
    : LISTING_PROFILE_HEADER_FOOTER_ACTION_UNAVAILABLE_TOOLTIP_KEY[action]
}

function getListingProfileHeaderFooterLifecycleAction(permissions) {
  return findKey(
    LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_PERMISSION_NAME,
    permissionName => permissions?.[permissionName]
  )
}

export function getListingProfileHeaderFooterActions({ listingData, t }) {
  const permissions = listingData?.permissions

  const lifecycleAction =
    getListingProfileHeaderFooterLifecycleAction(permissions)

  return filterVisibleItems([
    ...LISTING_PROFILE_HEADER_FOOTER_ACTION_ITEMS.map(({ Icon, action }) => {
      const tooltipKey = getActionDisabledTooltipKey({
        action,
        applicantCount: listingData?.counts?.applicants ?? 0,
      })

      return {
        Icon,
        action,
        disabled: Boolean(tooltipKey),
        isVisible: Boolean(
          permissions?.[
            LISTING_PROFILE_HEADER_FOOTER_ACTION_PERMISSION_NAME[action]
          ]
        ),
        qaName: LISTING_PROFILE_HEADER_FOOTER_ACTION_QA_NAME[action],
        text: t(LISTING_PROFILE_HEADER_FOOTER_ACTION_TEXT_KEY[action]),
        tooltipKey,
      }
    }),
    {
      Icon: LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_ICON[
        lifecycleAction
      ],
      action: lifecycleAction,
      isVisible: Boolean(lifecycleAction),
      qaName:
        LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_QA_NAME[lifecycleAction],
      text: lifecycleAction
        ? t(
            LISTING_PROFILE_HEADER_FOOTER_LIFECYCLE_ACTION_TEXT_KEY[
              lifecycleAction
            ]
          )
        : null,
    },
  ])
}

export function getListingProfileHeaderFooterMoreOptions({ actions, t }) {
  return actions.map(({ action, disabled, text, tooltipKey }) => ({
    disabled,
    label: text,
    tooltipContent: tooltipKey ? t(tooltipKey) : null,
    value: action,
  }))
}

export function getIsListingProfileHeaderFooterOnlyMore({
  hiddenActions,
  visibleActions,
}) {
  return hiddenActions.length > 0 && visibleActions.length < 1
}
